import React from 'react';
import {
  Card,
  Box,
  TextAction,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { useStaticAsset } from '@leagueplatform/asset-config';
import * as constants from '../../../common/constant';
import { EASYPLAN_ASSET_KEYS } from '../../../types/easy-plan-asset.types';

export function EasyPlanAboutCardItemsContainer(data: any) {
  const navigate = useNavigate();
  const { item } = data;
  const placeHolderImage = useStaticAsset(
    EASYPLAN_ASSET_KEYS.PLACEHOLDER_IMG,
  ) as string;
  const handleClickLink = (url: string) => {
    if (url === '/live-chat') {
      navigate('/support/live-chat');
    } else {
      navigate(url);
    }
  };
  return (
    <TextAction
      onClick={() => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          detail: item.title,
          screen_name: `${constants.ANALYTICS_SCREEN_NAME} - ${constants.ANALYTICS_ABOUT}`,
          product_area: constants.ANALYTICS_PRODUCT_AREA,
          path: window.location.pathname,
          event_author: constants.ENGEN,
        });
        handleClickLink(item.link);
      }}
      css={{
        display: 'block',
        '&:hover': {
          textDecoration: 'none',
        },
      }}
      data-testid="aboutItems"
    >
      <Card.Elevated
        imagePosition={{ '@initial': 'start', '@mobile': 'top' }}
        css={{
          padding: '$none $none $none $oneAndHalf',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Card.Image
          image={
            item.image && item.image !== '' ? item.image : placeHolderImage
          }
          imageAlt="COB header"
          css={{ width: '42px', alignSelf: 'center' }}
        />
        <Card.Section
          css={{
            padding: '$oneAndHalf $oneAndHalf $oneAndHalf $threeQuarters',
          }}
        >
          <Box>
            <UtilityText
              size="base"
              emphasis="emphasized"
              css={{
                fontWeight: '$headingTwo',
                lineHeight: '$subtitleOne',
                letterSpacing: '$subtitleOne',
                fontSize: '$subtitleOne',
                fontFamily: '$headingFour',
              }}
            >
              {item.title}
            </UtilityText>
          </Box>

          <UtilityText
            data-testid="aboutCardSubTitle"
            emphasis="base"
            css={{ fontSize: '$bodyTwo', lineHeight: '$subtitleTwo' }}
          >
            {item.subtitle}
          </UtilityText>
        </Card.Section>
      </Card.Elevated>
    </TextAction>
  );
}
